class LiveSearch {
    constructor() {
        this.searchInput = document.getElementById("live-search-input");
        this.resultsContainer = document.getElementById("live-search-results");
        this.searchForm = document.getElementById("live-search-form");
        this.debounceTimer = null;
        this.abortController = null;
        this.requestSequence = 0;

        if (this.searchInput && !this.searchInput.hasAttribute("data-live-search-initialized")) {
            this.searchInput.setAttribute("data-live-search-initialized", "true");
            this.init();
        }
    }

    init() {
        this.searchInput.addEventListener("input", (event) => this.handleInput(event));
        this.searchInput.addEventListener("focus", (event) => {
            if (event.target.value.trim().length >= 2) this.performSearch(event.target.value.trim());
        });
        this.searchInput.addEventListener("blur", () => {
            setTimeout(() => this.hideResults(), 200);
        });
        this.searchForm.addEventListener("submit", () => this.hideResults());
        document.addEventListener("click", (event) => {
            if (!this.searchForm.contains(event.target)) this.hideResults();
        });
    }

    handleInput(event) {
        const query = event.target.value.trim();
        clearTimeout(this.debounceTimer);

        if (query.length < 2) {
            this.requestSequence += 1;
            if (this.abortController) this.abortController.abort();
            this.hideResults();
            return;
        }

        this.debounceTimer = setTimeout(() => this.performSearch(query), 300);
    }

    async performSearch(query) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        const sequence = ++this.requestSequence;
        const params = new URLSearchParams({ q: query, limit: "8", typeahead: "1" });

        try {
            const response = await fetch(`/search?${params}`, {
                headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" },
                signal: this.abortController.signal
            });
            if (!response.ok) return;

            const html = await response.text();
            if (sequence !== this.requestSequence || this.searchInput.value.trim() !== query) return;
            this.displayResults(html);
        } catch (error) {
            if (error.name !== "AbortError") console.error("Search error:", error);
        }
    }

    displayResults(html) {
        // Rails owns the escaped result markup and local destination policy.
        // Keep the existing dropdown if a successful response is not a fragment.
        const document = new DOMParser().parseFromString(html, "text/html");
        const fragment = document.querySelector("[data-live-search-fragment]");
        if (!fragment) return;
        this.resultsContainer.replaceChildren(...fragment.childNodes);
        this.showResults();
    }

    showResults() {
        this.resultsContainer.classList.remove("d-none");
    }

    hideResults() {
        this.resultsContainer.classList.add("d-none");
    }
}

document.addEventListener("DOMContentLoaded", () => new LiveSearch());
document.addEventListener("turbo:load", () => new LiveSearch());
